import { subDays, differenceInDays } from "date-fns";

export const IoT_STATUS_COLORS = {
  GREEN: {
    color: "green",
    label: "cc_P_IoT_STATUS_GREEN",
  },
  ORANGE: {
    color: "orange",
    label: "cc_P_IoT_STATUS_ORANGE",
  },
  RED: {
    color: "red",
    label: "cc_P_IoT_STATUS_RED",
  },
  GREY: {
    color: "grey",
    label: "cc_P_IoT_STATUS_GREY",
  },
};

export const getIotStatusColor = (lastConnection: Date): string => {
  if (lastConnection) {
    const today = new Date();
    const daysBetween = differenceInDays(today, lastConnection);

    if (daysBetween < 3) {
      return IoT_STATUS_COLORS.GREEN.color;
    }

    if (daysBetween >= 3 && daysBetween <= 14) {
      return IoT_STATUS_COLORS.ORANGE.color;
    }

    if (daysBetween > 14) {
      return IoT_STATUS_COLORS.RED.color;
    }
  }

  // no history status
  return IoT_STATUS_COLORS.GREY.color;
};

export const getIoTStatusInterval = (
  status: string,
): {
  startDate: Date | null;
  endDate: Date | null;
} => {
  const today = new Date();

  switch (status) {
    case IoT_STATUS_COLORS.GREEN.color:
      // Last connection within 3 days (0-2 days ago)
      return {
        startDate: subDays(today, 2),
        endDate: null,
      };
    case IoT_STATUS_COLORS.ORANGE.color:
      // Last connection between 3-14 days ago
      return {
        startDate: subDays(today, 14),
        endDate: subDays(today, 3),
      };
    case IoT_STATUS_COLORS.RED.color:
      // Last connection more than 14 days ago
      return {
        startDate: null,
        endDate: subDays(today, 14),
      };

    case IoT_STATUS_COLORS.GREY.color:
    default:
      return {
        startDate: null,
        endDate: null,
      };
  }
};
